import React from "react";
import { Box, TextField, Button } from "@mui/material";
import { useGoogleMapSearchContext } from "./GoogleMapSearchContext";
import { useTranslation } from "react-i18next";
import { messages } from "../../../../locales/messages";

export const SearchInput: React.FC = () => {
  const { t } = useTranslation();
  const { query, setQuery, handleSearch, loading } =
    useGoogleMapSearchContext();

  return (
    <Box sx={{ mb: 2 }}>
      {" "}
      <Box
        component="h2"
        sx={{ fontWeight: 600, fontSize: 22, mb: 1, letterSpacing: 0.2 }}
      >
        {t(messages.Find_and_Select_Your_Store())}
      </Box>
      <Box sx={{ color: "text.secondary", fontSize: 15, mb: 2 }}>
        {t(
          messages.Search_for_your_store_by_name_Select_your_store_from_the_results()
        )}
      </Box>{" "}
      <TextField
        label={t(messages.Search_for_your_store())}
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && handleSearch()}
        fullWidth
        autoFocus
        size="medium"
        variant="outlined"
        InputProps={{
          sx: { fontSize: 18, fontWeight: 500, background: "#fafbfc" },
          "aria-label": t(messages.Store_search()),
        }}
        sx={{
          mb: 2,
          "& .MuiOutlinedInput-root": {
            "&:hover fieldset": { borderColor: "#02b7cf" },
            "&.Mui-focused fieldset": {
              borderColor: "#f58321",
              borderWidth: 2,
            },
          },
          "& .MuiInputLabel-root": { "&.Mui-focused": { color: "#f58321" } },
        }}
      />
      <Button
        variant="contained"
        onClick={handleSearch}
        disabled={!query || loading}
        sx={{
          mb: 2,
          minWidth: 120,
          fontWeight: 600,
          fontSize: 16,
          textTransform: "Capitalize",
          backgroundColor: "#f58321",
          "&:hover": { backgroundColor: "#e57100" },
          "&:disabled": { backgroundColor: "rgba(245, 131, 33, 0.3)" },
        }}
        aria-label={t(messages.Search_stores())}
      >
        {t(messages.Search())}
      </Button>
    </Box>
  );
};
